export interface DateRange {
  beginning?: Date;
  end?: Date;
}

export const isInRange = (range: DateRange, value: Date): boolean =>
  (range.beginning === undefined || range.beginning <= value) && (range.end === undefined || value < range.end);
